import { createFileRoute } from "@tanstack/react-router"

// Import the existing profile page component
import Profile from "@/features/users/components/profile-page"

export const Route = createFileRoute("/_app/profile")({
  component: ProfilePage
})

function ProfilePage() {
  return <Profile />
}
